import { VideoProvider } from "./Context/VideoContext";
import ChapterEditorMain from "./ChapterEditorMain";

const WrappedVideoEditorMain: React.FC<{ locale: string; setLocale: any }> = ({ locale, setLocale }) => {
    return (
      <VideoProvider>
        <ChapterEditorMain locale={locale} setLocale={setLocale} />
      </VideoProvider>
    );
  };
  
  export default WrappedVideoEditorMain;
  